/**
 * Step navigation and stat selection for the creator. Pure, so it is tested
 * without React. Legality of the crawler itself is decided by the rules engine
 * (validateDraft / buildCharacter), never here.
 */
import type { StatBlock, StatId } from '@dcc/rules/domain/stats.ts';
import { validateStandardArray } from '@dcc/rules/rules/characterCreation.ts';

export type CreatorStep = 'identity' | 'stats' | 'backgrounds' | 'combat' | 'review';
export type StatMethod = 'array' | 'roll';

export const CREATOR_STEPS: CreatorStep[] = ['identity', 'stats', 'backgrounds', 'combat', 'review'];

export const STEP_LABELS: Record<CreatorStep, string> = {
  identity: 'Identity',
  stats: 'Stats',
  backgrounds: 'Backgrounds',
  combat: 'Combat',
  review: 'Review',
};

export function nextStep(step: CreatorStep): CreatorStep {
  return CREATOR_STEPS[Math.min(CREATOR_STEPS.indexOf(step) + 1, CREATOR_STEPS.length - 1)] as CreatorStep;
}

export function previousStep(step: CreatorStep): CreatorStep {
  return CREATOR_STEPS[Math.max(CREATOR_STEPS.indexOf(step) - 1, 0)] as CreatorStep;
}

/** The finished stat block, or null while the chosen method is incomplete. */
export function chosenStats(
  method: StatMethod,
  assignment: Partial<Record<StatId, number>>,
  rolled: StatBlock | null,
): StatBlock | null {
  if (method === 'roll') return rolled;
  return validateStandardArray(assignment).valid ? (assignment as StatBlock) : null;
}

export function canAdvance(step: CreatorStep, name: string, stats: StatBlock | null): boolean {
  if (step === 'identity') return name.trim().length > 0;
  if (step === 'stats') return stats !== null;
  return true;
}
